import { instance, errorService } from '@/services/api'
import { masterAPIs, screenType } from '@/services/authConstantsV1'
import { gridProperties } from '@/services/column.config'
import {
  calculateGridHeight,
  showNotification,
  customComparator,
} from '@/services/calculate'
import { AgGridVue } from 'ag-grid-vue'
import _ from 'lodash'
import Pagination from '@/components/DynamicComponents/Pagination'
import { tableName } from '@/services/config'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
    Pagination,
  },
  props: {
    tabKey: String,
    type: String,
    role: String,
    screenId: Number,
    columnSettings: Array,
  },
  data: function() {
    const checkLength = (rule, value, callback) => {
      if (rule.field === 'unit') {
        if (String(value).length > 100) {
          callback(
            new Error('Unit must be less than or equals to 100 characters'),
          )
        } else {
          callback()
        }
      } else {
        if (String(value).length > 500) {
          callback(
            new Error(
              'Description must be less than or equals to 500 characters',
            ),
          )
        } else {
          callback()
        }
      }
    }
    return {
      headStyle: {
        'font-weight': 'bold',
        background: 'transparent !important',
        color: '#000000d9 !important',
        padding: '0 10px',
      },
      count: 0,
      loading: true,
      spinner: false,
      defaultSortedBy: 'unit',
      defaultSortOrder: true,
      page: 0,
      pageSize: 0,
      unitList: [],
      visible: false,
      modalTitle: '',
      form: {
        id: undefined,
        unit: undefined,
        description: undefined,
        isActive: 1,
      },
      rules: {
        unit: [
          { required: true, message: 'Please enter unit', trigger: 'blur' },
          { validator: checkLength, trigger: 'blur' },
        ],
        description: [
          {
            required: true,
            message: 'Please enter description',
            trigger: 'blur',
          },
          { validator: checkLength, trigger: 'blur' },
        ],
      },
      loadUnits: false,
      selectedRowKeys: [],
      loadRefresh: false,
      // gridOptions: null,
      // columnDefs: [],
      frameworkComponents: null,
      tableParams: null,
      width: '100%',
      height: '410px',
      filters: {},
      tableState: null,
      gridOptions: {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        tooltipShowDelay: 0,
        rowSelection: 'multiple',
        defaultColDef: {
          sortable: true,
          suppressMovable: true,
          comparator: customComparator,
          resizable: true,
          menuTabs: ['filterMenuTab'],
          filterParams: {
            buttons: ['apply'],
            newRowsAction: 'keep',
          },
        },
      },
      columnDefs: [],
    }
  },
  beforeMount() {
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.pageSize = settings.application.defaultRecord
    this.loadingConfig()
  },
  mounted() {
    this.$root.$on('deleteUnit', this.deleteUnit)
    this.$root.$on('editUnit', this.getUnitById)
    window.addEventListener('resize', this.getWindowSize)
  },
  watch: {
    tabKey() {
      if (this.tabKey === '6') {
        this.filters = {}
        const data = this.gridOptions.api.getFilterModel()
        Object.keys(data).forEach(element => {
          const filterComponent = this.gridOptions.api.getFilterInstance(
            element,
          )
          filterComponent.setModel(null)
        })
        this.unitList = []
        this.loading = true
        this.getColumnSettings(this.gridOptions)
      }
    },
  },
  beforeDestroy() {
    this.$root.$off('editUnit')
    this.$root.$off('deleteUnit')
    window.removeEventListener('resize', this.getWindowSize)
  },
  methods: {
    loadingConfig() {
      this.frameworkComponents = gridProperties.master.frameworks
      this.gridOptions.isRowSelectable = node => {
        if (node.data) {
          if (node.data.isLinked) return false
          else return true
        }
      }
      gridProperties.master.columns.unit.map(i => {
        if (i.field === 'action' || i.field === 'isActive' || !i.field) {
          i.hide = this.role !== 'Admin' && this.type === 'Template'
        }
      })
      this.columnDefs = gridProperties.master.columns.unit
    },

    // Refresh Units
    refreshUnits() {
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach(element => {
        const filterComponent = this.gridOptions.api.getFilterInstance(element)
        filterComponent.setModel(null)
      })
      this.loading = true
      this.loadRefresh = true
      this.unitList = []
      this.page = 0
      this.defaultSortedBy = 'unit'
      this.defaultSortOrder = true
      this.selectedRowKeys = []
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'unit',
            sort: 'asc',
          },
        ],
        defaultState: { sort: null },
      })
      this.gridOptions.api.destroyFilter()
      this.filters = {}
      this.getUnits(this.gridOptions)
    },

    // Close the dialog
    handleCancel() {
      this.visible = false
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Add new unit
    addNew() {
      this.visible = true
      this.modalTitle = 'Add New Unit'
      this.form.unit = undefined
      this.form.id = null
      this.form.isActive = 1
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Save & Update unit
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.spinner = true
          let url = masterAPIs.unit.add
          let method = 'post'
          const req = {
            unit: this.form.unit,
            description: this.form.description,
          }
          if (this.form.id) {
            url = masterAPIs.unit.details(this.form.id)
            method = 'patch'
          }
          instance[method](url, req)
            .then(response => {
              this.spinner = false
              this.visible = false
              showNotification(
                'success',
                this.form.id ? 'Update Unit' : 'Create Unit',
                this.form.id
                  ? 'Unit updated successfully!'
                  : 'Unit created successfully!',
              )
              if (this.form.id) {
                const newData = [...this.unitList]
                const index = newData.findIndex(i => i.id === this.form.id)
                newData[index] = _.get(response.data, 'result', null)
                this.unitList = newData
              } else {
                this.getUnits(this.tableParams)
              }
              this.$refs.ruleForm.resetFields()
            })
            .catch(error => {
              this.spinner = false
              errorService(error)
            })
        }
      })
    },

    // Load Units
    getUnits(params, type) {
      instance
        .post(masterAPIs.unit.list, {
          pageSize: this.pageSize,
          currentPage: this.page,
          sortColumn: this.defaultSortedBy,
          isAscending: this.defaultSortOrder,
          unit: _.get(this.filters, 'unit', undefined),
          description: _.get(this.filters, 'description', undefined),
        })
        .then(response => {
          this.tableParams = null
          this.tableParams = params
          this.unitList = _.get(response.data, 'result', [])
          this.count = _.get(response.data, 'totalCount', 0)
          this.height = calculateGridHeight(
            'unitTable',
            this.count > this.pageSize,
          )
          this.loading = false
          this.loadRefresh = false
          if (type === 'sort') {
            this.updateColumnSettings()
          }
        })
        .catch(error => {
          this.loading = false
          this.loadRefresh = false
          errorService(error)
        })
    },

    // Get Unit By Id
    getUnitById(id) {
      this.visible = true
      this.modalTitle = 'Edit'
      this.spinner = true
      instance
        .get(masterAPIs.unit.details(id))
        .then(response => {
          this.form.id = _.get(response.data, 'result.id', null)
          this.form.unit = _.get(response.data, 'result.unit', null)
          this.form.description = _.get(
            response.data,
            'result.description',
            null,
          )
          this.form.isActive = _.get(response.data, 'result.isActive', 0)
          this.spinner = false
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    // Export Unit Excel Sheet
    exportUnits() {
      this.loadUnits = true
      instance
        .get(masterAPIs.exportUnit)
        .then(response => {
          this.loadUnits = false
        })
        .catch(error => {
          this.loadUnits = false
          errorService(error)
        })
    },

    confirmDelete(record) {
      this.loading = true
      const ids = record ? [record.id] : this.selectedRowKeys
      instance
        .patch(masterAPIs.unit.delete, ids)
        .then(response => {
          showNotification(
            'success',
            'Delete Unit',
            'Unit deleted successfully!',
          )
          this.refreshUnits()
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    // Delete All Property Sub Types
    deleteAllType() {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete ${this.selectedRowKeys.length} selected units ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to selected units
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(null)
        },
        onCancel() {},
        class: 'test',
      })
    },

    // Delete Unit
    deleteUnit(data) {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete '${data.unit}' ?`,
        content: h => (
          <div style="color:red;">
            <p>This action will delete all information related to this unit</p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(data)
        },
        onCancel() {},
        class: 'test',
      })
    },

    // Ag Grid sort method
    sortChanged(value) {
      const colState = this.gridOptions.columnApi.getColumnState()
      const sortData = colState
        .filter(function(s) {
          return s.sort != null
        })
        .map(function(s) {
          return {
            colId: s.colId,
            sort: s.sort,
            sortIndex: s.sortIndex,
          }
        })
      this.loading = true
      this.unitList = []
      if (sortData.length > 0) {
        this.defaultSortedBy = sortData[0]['colId']
        this.defaultSortOrder = sortData[0]['sort'] === 'asc'
      } else {
        this.defaultSortedBy = 'unit'
        this.defaultSortOrder = true
      }
      this.getUnits(this.gridOptions, 'sort')
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    getWindowSize() {
      this.height = calculateGridHeight(
        'unitTable',
        this.count > this.pageSize,
      )
    },

    onPagination(page) {
      this.loading = true
      this.page = page
      this.unitList = []
      this.selectedRowKeys = []
      this.getUnits(this.tableParams)
    },

    filterChanged() {
      this.filters = {}
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach((element, index) => {
        this.filters[element] = Object.values(data)[index]['filter']
      })
      this.loading = true
      this.page = 0
      this.unitList = []
      this.getUnits(this.gridOptions)
    },

    onColumnResized(e) {
      if (e.finished) {
        this.updateColumnSettings()
      }
    },

    updateColumnSettings() {
      if (this.role === 'Admin') {
        this.tableState = this.gridOptions.columnApi.getColumnState()
        const request = {
          type: !this.type ? screenType.unit : undefined,
          screenId: this.type ? this.screenId : undefined,
          tableName: this.type ? tableName.template.master.unit : undefined,
          columnDetails: JSON.stringify(this.tableState),
        }
        if (!this.type) {
          this.$emit('updateColumns', request)
        } else {
          this.$emit('updateColumnSettings', request)
        }
      }
    },

    getColumnSettings(params) {
      if (this.type) {
        const columnDetails = this.columnSettings.find(
          i =>
            i.screenId === this.screenId &&
            i.tableName === tableName.template.master.unit,
        )
        this.setColumnSettings(
          params,
          columnDetails ? columnDetails.columnDetails : null,
        )
        this.getUnits(this.gridOptions)
      } else {
        if (this.role === 'Admin') {
          instance
            .get(masterAPIs.columnSetting.get(screenType.unit))
            .then(response => {
              const tableState = _.get(
                response.data,
                'result.columnDetails',
                null,
              )
              this.setColumnSettings(params, tableState)
            })
            .catch(error => {
              this.spinner = false
              errorService(error)
            })
        } else {
          this.setColumnSettings(params)
        }
        this.getUnits(this.gridOptions)
      }
    },

    setColumnSettings(params, tableState) {
      if (tableState && this.role === 'Admin') {
        this.tableState = JSON.parse(tableState)
        if (this.tableState.find(i => i.sort)) {
          this.defaultSortedBy = this.tableState.find(i => i.sort).colId
          this.defaultSortOrder =
            this.tableState.find(i => i.sort).sort === 'asc'
        }
        this.tableState[0].hide = !!this.type
        this.gridOptions.columnApi.applyColumnState({
          state: this.tableState,
        })
      } else {
        this.defaultSortedBy = 'unit'
        this.defaultSortOrder = true
        this.gridOptions.columnApi.applyColumnState({
          state: [
            {
              colId: 'unit',
              sort: 'asc',
            },
            {
              colId: 'action',
              hide: this.role !== 'Admin' || this.type === 'Template',
            },
            {
              colId: 'isActive',
              hide: this.role !== 'Admin' || this.type === 'Template',
            },
            {
              colId: '0',
              hide: this.role !== 'Admin' || this.type === 'Template',
            },
          ],
          defaultState: { sort: null },
        })
        params.api.sizeColumnsToFit()
      }
    },
  },
}
